import { jsx as _jsx } from "react/jsx-runtime";
import { useLanguage } from "@/app";
import { translations } from "@/widgets/web/sidebar/constants";
import { Modal } from "@/shared/ui";
import { trackEvent } from "@/shared/lib/analytics";
import { AnalyticsEvent } from "@/shared/lib/analyticsEvents";
import { ymReachGoalOnce, } from "@/shared/lib/yandexMetrika";
import { useMySubscription } from "@/features/subscription";
import { getStorefrontItems, isSubscriptionPackage, shouldShowEmptyStorefront, } from "@/shared/lib/subscriptionView";
import { useEffect } from "react";
import { BuyPackageCard } from "../BuyPackageCard/BuyPackageCard";
import { SubscriptionPackageCard, SubscriptionPackageCardSkeleton, } from "../SubscriptionPackageCard/SubscriptionPackageCard";
import styles from "./BuyPackageModal.module.scss";
export const BuyPackageModal = ({ isTopUpModalOpen, setIsTopUpModalOpen, isLoadingPackages, packages, }) => {
    const { language } = useLanguage();
    const t = translations[language];
    // Действующая подписка → подписочные пакеты не предлагаем. Модалка живёт в
    // сайдбаре на каждой странице, поэтому за подпиской ходим, только когда она
    // открыта.
    const subscriptionState = useMySubscription({ enabled: isTopUpModalOpen });
    const storefront = getStorefrontItems(packages, subscriptionState);
    // Открыт попап тарифов = просмотр списка пакетов (контракт: одно packages_view
    // и на странице баланса, и на этом попапе — отдельного события нет).
    useEffect(() => {
        if (isTopUpModalOpen) {
            trackEvent(AnalyticsEvent.PACKAGES_VIEW);
            // Ступень воронки Метрики (см. yandexMetrika). Once: модалку открывают и
            // закрывают по нескольку раз за визит, а воронка считает визиты.
            ymReachGoalOnce("checkout_open", { placement: "topup_modal" });
        }
    }, [isTopUpModalOpen]);
    return (_jsx(Modal, { opened: isTopUpModalOpen, onClose: () => setIsTopUpModalOpen(false), title: t.topUpBalance, size: "lg", children: isLoadingPackages ? (_jsx("div", { className: styles.stateRow, children: _jsx("span", { className: styles.stateText, children: t.loadingPackages }) })) : storefront.length === 0 ? (_jsx("div", { className: styles.stateRow, children: _jsx("span", { className: styles.stateText, children: shouldShowEmptyStorefront(storefront, subscriptionState)
                    ? language === "ru"
                        ? "Пакеты не найдены"
                        : "No packages found"
                    : language === "ru"
                        ? "У вас уже есть подписка"
                        : "You already have a subscription" }) })) : (_jsx("div", { className: styles.cardsGrid, children: storefront.map(({ pkg, state }) => state === "pending" ? (_jsx(SubscriptionPackageCardSkeleton, {}, pkg.id)) : isSubscriptionPackage(pkg) ? (_jsx(SubscriptionPackageCard, { packageItem: pkg, setIsTopUpModalOpen: setIsTopUpModalOpen }, pkg.id)) : (_jsx(BuyPackageCard, { packageItem: pkg, setIsTopUpModalOpen: setIsTopUpModalOpen }, pkg.id))) })) }));
};
